import { Sheet as FrameworkSheet } from '@ulam/sili/react'

export default function A11ySheet(props) {
  return <FrameworkSheet {...props} />
}

